import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { BehaviorSubject } from 'rxjs'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import {
  deleteRentalComplete,
  Destroyable,
  isSomething,
  loadRental,
  Rental,
  selectRentalById,
  selectSome,
  untilDestroy,
} from '@tokeet/tv3-platform'
import { tap } from 'rxjs/operators'

export enum RentalDialogTab {
  Calendar,
  Basic,
  Location,
  Custom,
  Info,
  Gallery,
  Instructions,
}

@Component({
  selector: 'app-rental-overlay',
  templateUrl: './rental-overlay.component.html',
  styleUrls: ['./rental-overlay.component.scss'],
})
export class RentalOverlayComponent extends Destroyable implements OnInit {
  tab$ = new BehaviorSubject(RentalDialogTab.Basic)
  tabs = RentalDialogTab

  rental: Rental

  hasIncompleteCheckInOut = false

  constructor(
    private actions: Actions,
    public dialogRef: MatDialogRef<RentalOverlayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rental: Rental; activeTab: RentalDialogTab; highlightedImages?: string[] },
    private store: Store<fromRoot.State>
  ) {
    super()
  }

  ngOnInit() {
    this.tab$.next(this.data.activeTab)

    this.rental = this.data.rental

    this.store.dispatch(loadRental({ id: this.rental.id }))

    this.store
      .pipe(
        selectSome(selectRentalById(this.rental.id)),
        tap((rental) => {
          this.hasIncompleteCheckInOut = !isSomething(rental.checkin) || !isSomething(rental.checkout)
        }),
        untilDestroy(this)
      )
      .subscribe((rental) => {
        this.rental = rental
      })

    this.actions.pipe(ofType(deleteRentalComplete.type), untilDestroy(this)).subscribe(() => {
      this.close()
    })
  }

  close() {
    this.dialogRef.close()
  }
}
